<template>
  <ModelForm
    :places="places"
    :reports="reports"
    :user="user"
  />
</template>

<script>

import BaseLayout from '@/Layouts/BaseLayout';
import UiBreadcrumbs from '@/components/Ui/UiBreadcrumbs';
import UiErrors from '@/components/Ui/UiErrors';
import UiDeleteButton from '@/components/Ui/UiDeleteButton';
import Form from "./UsersForm";

export default {
  name: 'UsersEdit',
  components: {
    UiBreadcrumbs,
    BaseLayout,
    UiErrors,
    UiDeleteButton,
    ModelForm: Form
  },
  props: {
    reports: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    places: {
      type: Array,
      required: true
    },
    errors: {
      type: Object,
      default: () => null
    },
  },
  data() {
    return {
      breadcrumbs: null,
      form: this.$inertia.form({
        _method: 'put',
        ...this.user,
      }),
      rules: {
        name: [
          {required: true, message: 'Обязательное поле', trigger: 'blur'},
        ],
        email: [
          {required: true, message: 'Обязательное поле', trigger: 'blur'},
        ],
      },
    };
  },
  computed: {
    isNew() {
      return !(this.user.id);
    },
    title() {
      return this.isNew ? 'Создание записи' : 'Изменение записи';
    },
  },
  methods: {
    deleteClick() {
      this.$inertia.delete(route('users.destroy', this.user.id), {
        onSuccess: () => {
          this.$notify.success({
            title: 'Успешно',
            message: 'Удаление было совершено успешно!',
          });
        },
        onError: (errors) => {
          this.$notify.error({
            title: 'Ошибка',
            message: errors.exeption[0],
          });
        },
      });
    },
    validate() {
      return this.$refs.users_form.validate();
    },
    submitForm(settings) {
      const url = this.isNew ? route('users.store') : route('users.update', this.user.id);
      // Так как PUT метод не поддерживает загрузку файлов
      if (!this.isNew) {
        this.form._method = 'put';
      }
      return this.form.post(url, settings);
    },
    submit() {
      this.validate().then(() => {
        this.submitForm({
          onError: () => {
            this.$notify.error({
              title: 'Ошибка сохранения',
              message: 'Исправьте введенные данные',
            });
          },
        });
      }).catch(() => {
        this.$notify.error({
          title: 'Ошибки в форме',
          message: 'Заполните необходимые поля',
        });
      });
    }
  }
};
</script>
